import * as env from '../env.json';

export { env };

export function apiUrl(path) {
  const base = env.contours.basePath || '';
  return `${base}${path}`;
}

export function geocoderUrl(query) {
  return `/geocodeproxy/geocode?q=${query}`;
}
